import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Restaurant } from '../models/restaurant.model';
import { ToastaddService } from '../services/toastadd.service';

@Component({
    selector: 'app-v2',
    templateUrl: './v2.page.html',
    styleUrls: ['./v2.page.scss'],
})
export class V2Page implements OnInit {

    rest$: Observable<Restaurant>
    /**
     * Diz em qual segmento da URL o usuário está
     */
    public topbarMode$: Observable<string>

    constructor(
        private router: Router,
        private toastAdd: ToastaddService
    ) { }

    ngOnInit() {
        this.topbarMode$ = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map((event: NavigationEnd) => event.urlAfterRedirects.replace(`/${environment.routePaths.v2.version}/`, '') || 'home'),
        )
    }
    
    closeToast(){
        this.toastAdd.closeToast()        
    }

}
